@if (dokumente.value().length || unsavedDokumente().length || availableUploads().length) {
  <div class="panel panel-default text-left">
    <div class="panel-heading">
      <div class="panel-title">
        {{ 'dokument.title' | translate }}
      </div>
    </div>
    <div class="panel-body" [ngClass]="{'has-error': errorMessage().length}">

      <div class="row">
        <div class="col-sm-12 mb-0">
          <div class="col-sm-12 mb-0">
            @if (showAlertImmunologisch) {
              <p class="tam-alert mb-15">
                <i [class]="iconAlertImmunologisch"></i>
                <span [innerHTML]="'meldung.feld.praeparat.alert.immunologisch' | translate | marked:true"></span>
              </p>
            }
            @if (showAlertLieferEngpass) {
              <p class="tam-alert mb-15">
                <i [class]="iconAlertLieferEngpass"></i>
                <span [innerHTML]="'meldung.feld.praeparat.alert.lieferEngpass' | translate | marked:true | injectUrl:'url.lieferEngpass'"></span>
              </p>
            }
          </div>
        </div>
      </div>

      @if (dokumente.value().length || unsavedDokumente().length) {
        <table class="dokument-table">
          @for (dokument of dokumente.value(); track dokument.id) {
            <tr [class]="dokument.highlight">
              <td>{{ dokument.typ.messageProperty | translate }}</td>
              <td>
                <a class="cursor-pointer" (click)="downloadDokument(dokument)">
                  {{ dokument.name }}
                </a>
              </td>
              <td>
                @if (canDelete(dokument)) {
                  <span class="glyphicon glyphicon-trash cursor-pointer"
                        [matTooltip]="'global.tooltip.dokument.loeschen' | translate" matTooltipPosition="right"
                        (click)="deleteDokument(dokument)"></span>
                }
              </td>
              <td>
                @if (dokument.typ.canMarkUnread && !dokument.highlight) {
                  <span class="glyphicon glyphicon-eye-close cursor-pointer"
                        [matTooltip]="'global.tooltip.dokument.ungelesen' | translate" matTooltipPosition="right"
                        (click)="markUnread(dokument)"></span>
                }
              </td>
            </tr>
          }
          @for (dokument of unsavedDokumente(); track dokument.id) {
            <tr [class]="dokument.highlight">
              <td>{{ dokument.typ.messageProperty | translate }}</td>
              <td>
                <a class="cursor-pointer" (click)="downloadDokument(dokument)">
                  {{ dokument.name }}
                </a>
              </td>
              <td>
                @if (canDelete(dokument)) {
                  <span class="glyphicon glyphicon-trash cursor-pointer"
                        [matTooltip]="'global.tooltip.dokument.loeschen' | translate" matTooltipPosition="right"
                        (click)="deleteDokument(dokument)"></span>
                }
              </td>
              <td></td>
            </tr>
          }
        </table>
      }
      @if (unsavedDokumente().length) {
        <div class="row mt-15">
          <div class="col-sm-12 mb-0">
            <button class="btn btn-primary ml-15" (click)="saveDokumente()">
              {{ 'global.save' | translate }}
            </button>
          </div>
        </div>
      }
      @if (availableUploads().length) {
        <div class="row" [ngClass]="{'mt-15': dokumente.value().length || unsavedDokumente().length}">
          <div class="col-sm-12 mb-0">
            <div class="col-sm12 mb-0">
              <input class="hidden" type="file" [accept]="'dokument.extensions' | setting" (change)="uploadDokument($event)" #fileInput>
              @for (dokumentTyp of availableUploads(); track dokumentTyp.id) {
                <button class="btn btn-default ml-15" (click)="selectDokument(dokumentTyp)">{{ dokumentTyp.messageProperty | translate }}</button>
              }
            </div>
            @for (msg of errorMessage(); track msg) {
              <div class="col-sm-12 mb-0 help-block" role="alert">{{ msg }}</div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
